module.exports = {
  locales: ['en-de', 'de-de', 'en-at', 'de-at'],
}
